// @ts-nocheck
import React from "react";

import "./loader.component.css";
import PubSub from "pubsub-js";
import { eventNames } from "../../../constants/eventNames";

export default class Loader extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isTreeLoading: false
    };
    this.subscribeToPreloaderActions();
  }

  subscribeToPreloaderActions = () => {
    PubSub.subscribe(eventNames.showLoader, () => {
      this.setState({
        isLoading: true
      });
    });
    PubSub.subscribe(eventNames.hideLoader, () => {
      this.setState({
        isLoading: false
      });
    });
    PubSub.subscribe(eventNames.showTreeComLoader, () => {
      this.setState({
        isTreeLoading: true
      });
    });
    PubSub.subscribe(eventNames.hideTreeComLoader, () => {
      this.setState({
        isTreeLoading: false
      });
    });
  };

  componentWillUnmount() {
    PubSub.unsubscribe(eventNames.showLoader);
    PubSub.unsubscribe(eventNames.hideLoader);
    PubSub.unsubscribe(eventNames.showTreeComLoader);
    PubSub.unsubscribe(eventNames.hideTreeComLoader);
  }

  render() {
    return this.state.isLoading || this.state.isTreeLoading ? (
      <div className="loader-div">
        <div className="loader">
          <span>&nbsp;&nbsp;&nbsp;Loading...</span>
        </div>
      </div>
    ) : null;
  }
}
